import { Badge, Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { Bath, MapPin, MessageCircle, PawPrint, Phone, Scissors, Sparkles } from "lucide-react";

export function Home() {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-secondary to-background pointer-events-none" />
        <div className="relative mx-auto max-w-6xl px-6 pt-20 pb-16 sm:pt-28 sm:pb-24">
          <div className="flex flex-col items-center text-center gap-6">
            <div className="inline-flex items-center gap-3 rounded-full bg-secondary px-4 py-2 text-sm text-secondary-foreground">
              <PawPrint className="size-4" />
              Doggy-Doo • Bangkok, Thailand
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight">
              Simple, gentle, and fun dog grooming
            </h1>
            <p className="max-w-2xl text-muted-foreground text-base sm:text-lg">
              Bath, trim, and styling done with care. A bright, friendly spot your pup will love.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
              <Button size="lg" className="gap-2">
                <Phone className="size-4" /> Call to Book
              </Button>
              <Button size="lg" variant="outline" className="gap-2">
                <MessageCircle className="size-4" /> Message LINE
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="mx-auto max-w-6xl px-6 py-14 sm:py-20">
        <div className="flex flex-col items-center text-center gap-3 mb-10">
          <Badge className="bg-accent text-accent-foreground">Services</Badge>
          <h2 className="text-3xl sm:text-4xl font-semibold">Everything your pup needs</h2>
          <p className="text-muted-foreground max-w-2xl">
            Thoughtful, stress-free grooming with gentle products and lots of cuddles.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="border-none shadow-none bg-card">
            <CardHeader className="space-y-2">
              <div className="inline-flex size-12 items-center justify-center rounded-full bg-secondary">
                <Bath className="size-6 text-primary" />
              </div>
              <CardTitle>Fresh Bath</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              Warm bath, blow-dry, ear cleaning, and a fluffy finish.
            </CardContent>
          </Card>
          <Card className="border-none shadow-none bg-card">
            <CardHeader className="space-y-2">
              <div className="inline-flex size-12 items-center justify-center rounded-full bg-secondary">
                <Scissors className="size-6 text-primary" />
              </div>
              <CardTitle>Groom & Style</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              Breed-specific cuts or a cute tidy-up—always comfortable and safe.
            </CardContent>
          </Card>
          <Card className="border-none shadow-none bg-card">
            <CardHeader className="space-y-2">
              <div className="inline-flex size-12 items-center justify-center rounded-full bg-secondary">
                <Sparkles className="size-6 text-primary" />
              </div>
              <CardTitle>Nails & Care</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              Nail trim, paw balm, and a final spritz for that happy tail wag.
            </CardContent>
          </Card>
        </div>
      </section>

      {/* About / Location */}
      <section className="mx-auto max-w-6xl px-6 pb-16 sm:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="space-y-4">
            <h3 className="text-2xl sm:text-3xl font-semibold">Hello from Bangkok</h3>
            <p className="text-muted-foreground">
              We’re a small, friendly grooming studio in Bangkok focused on calm, kind care. Our
              space is bright and clean—perfect for nervous pups and first-time visits.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <div className="inline-flex items-center gap-2 text-muted-foreground">
                <MapPin className="size-4" /> Bangkok, Thailand
              </div>
              <div className="inline-flex items-center gap-2 text-muted-foreground">
                <Phone className="size-4" /> 09X-XXX-XXXX
              </div>
            </div>
          </div>
          <div className="rounded-2xl border bg-secondary/40 p-8 text-center">
            <div className="mx-auto inline-flex size-20 items-center justify-center rounded-full bg-secondary">
              <PawPrint className="size-10 text-primary" />
            </div>
            <p className="mt-4 text-muted-foreground">Cute photos coming soon!</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto max-w-6xl px-6 pb-24">
        <div className="rounded-2xl border bg-gradient-to-br from-secondary to-background p-8 sm:p-12 text-center">
          <h4 className="text-2xl sm:text-3xl font-semibold mb-3">Ready for a fresh, happy pup?</h4>
          <p className="text-muted-foreground mb-6">
            Book a simple bath or a full groom—always gentle, always kind.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Button size="lg" className="gap-2">
              <Phone className="size-4" /> Call to Book
            </Button>
            <Button size="lg" variant="outline" className="gap-2">
              <MessageCircle className="size-4" /> Message LINE
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
